import axiosHttp from '@/utils/httpRequest'


// 知识产权类型  通过字典获取
export const getPatentType = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/display/getPatentType',
        params
    })
};


// 获取知识产权数据列表  通过分页内容获取
export const getPatentList = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/display/data',
        params
    })
};

// 获取专利出售的列表信息
export const getSalesList = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/sales/sales/yyptShowData',
        params
    })
};


// 获取需求的列表的信息
export const getRequirementList = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/requirement/requirement/data',
        params
    })
};


// 专家团队信息
export const getTeamList = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/team/team/data',
        params
    })
};



// 专家信息
export const getExpertList = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/display/getExpertList',
        params
    })
};




// 专题库数据
export const getLibraryList = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/patent/apply/apply/ztData',
        params
    })
};


// 获取新闻资讯的列表信息
export const getNewsList = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/news/news/data',
        params
    })
};


// 新闻资讯的详情
export const getNewsDetail = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/news/news/getDetail',
        params
    })
};


// 专利明细
export const getPatentDetail = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/display/getPatentDetail',
        params
    })
};


// 技术供应 明细
export const getSalesDetail = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/sales/sales/getDetail',
        params
    })
};


// 需求的详情
export const getRequirementDetail = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/requirement/requirement/getDetail',
        params
    })
};

// 注册用户查看自己发布的需求（登录态由 Authorization 请求头携带）
export const listMyRequirement = () => {
    return axiosHttp({
        method: 'get',
        url: '/cms/requirement/requirement/listByToken'
    })
};
// 发布需求（登录态由 Authorization 请求头携带）
export const addRequirement = (data) => {
    return axiosHttp({
        method: 'post',
        url: '/cms/requirement/requirement/add',
        data
    })
};




// 获取团队详情
export const getTeamDetail = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/team/team/getDetail',
        params
    })
};

// 获取团队成员
export const getTeamStaff = (params) => {
    return axiosHttp({
        method: 'get',
        url: '/cms/team/team/getTeamStaff',
        params
    })
};


// 获取当前登录用户信息（登录态由 Authorization 请求头携带）
export const getCmsUser = () => {
    return axiosHttp({
        method: 'post',
        url: '/cms/user/cmsUser/getCmsUser'
    })
};


export const updateCmsUser = (data) => {
    return axiosHttp({
        method: 'post',
        url: '/cms/user/cmsUser/updateCmsUser',
        data
    })
};


// 修改密码：需提交原密码 oldPwd 与新密码 pwd
export const updateCmsUserPassword = (data) => {
    return axiosHttp({
        method: 'post',
        url: '/cms/user/cmsUser/updateCmsPwd',
        data
    })
};


// 用户登录（账号密码走表单体提交，不进 URL）
export const login = (data) => {
    return axiosHttp({
        method: 'post',
        url: '/cms/user/cmsUser/login',
        data
    })
};

// 用户注册（账号密码走表单体提交，不进 URL）
export const register = (data) => {
    return axiosHttp({
        method: 'post',
        url: '/cms/user/cmsUser/register',
        data
    })
};





